import Api from './apiHandler'
const BASE = 'friends'

const FriendApi = {
  getMyFriends: () => Api.get(`${BASE}/my-friend`),
  addFriend: (data) => Api.post(`${BASE}/req-friend`, data),
  rejectFriend: (data) => Api.patch(`${BASE}/refuse-friend`, data),
  accFriend: (data) => Api.patch(`${BASE}/acc-friend`, data),
  deleteFriend: (id) => Api.delete(`${BASE}/${id}`),
  unfriend: (id) => Api.delete(`${BASE}/unfriend/${id}`),
}

export default FriendApi
